module.exports = __webpack_public_path__ + "static/media/m1.7122dbbb.webp";